module.exports = __webpack_public_path__ + "841c0257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard_image.jpg
// module id = 838
// module chunks = 0 1 2 3 4 5